
import { defineComponent, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useStarRouter } from '@/utils/useStarTheme'
import starApi from '@/api/starApi'

interface HistoryItem {
  taskID: string
  title: string
  quantType: number
  backTestTime: number
}

function formatTitle(item: HistoryItem): string {
  return item.title
}

function formatTime(ts: number): string {
  if (!ts) return '--'
  const d = new Date(ts)
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
}

export default defineComponent({
  name: 'StarResult',
  setup() {
    const route = useRoute()
    const { starPush } = useStarRouter()
    const loading = ref(false)
    const list = ref<HistoryItem[]>([])

    const fetchList = async () => {
      loading.value = true
      try {
        const token = route.query.token as string
        const res = await starApi.getBacktestHistory({ headers: { token } })
        list.value = (res?.data?.list || []).sort((a: HistoryItem, b: HistoryItem) => b.backTestTime - a.backTestTime)
      } catch (e) {
        list.value = []
      } finally {
        loading.value = false
      }
    }

    const goDetail = (item: HistoryItem) => {
      const isGroup = item.quantType === 3 || item.quantType === 4
      starPush(isGroup ? '/star/group/result' : '/star/stock/result', { taskID: item.taskID, title: item.title, isDetails: 'true', isfrom: '1' })
    }

    onMounted(fetchList)

    return { loading, list, formatTitle, formatTime, goDetail }
  }
})
